export default "__VITE_ASSET__BMOJCW8M__"